import { createReducer } from "@reduxjs/toolkit";
import {
  GET_GOOGLE_FORMS,
  GOOGLE_FORMS_ADD,
  GOOGLE_FORMS_ERROR,
  GOOGLE_FORMS_LOADING,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const googleFormsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(GOOGLE_FORMS_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(GOOGLE_FORMS_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(GET_GOOGLE_FORMS, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    })
    .addCase(GOOGLE_FORMS_ADD, (state, { payload }) => {
      state.data.push(payload);
      state.loading = false;
    });
});

export default googleFormsReducer;
